module.exports = __webpack_public_path__ + "static/media/how-it-works-3.3ce998c6.jpg";